// Seven classes. `v` and `s` name CSS custom properties defined in styles/tokens.css —
// a foreground and a soft background per class. Adding a class means adding both
// tokens in all three theme blocks.

export const CLASSES = [
  { id: "15.010", name: "Economic Analysis", full: "Economic Analysis for Business Decisions", v: "--c010", s: "--c010s" },
  { id: "15.060", name: "Data, Models & Decisions", full: "Data, Models, and Decisions", v: "--c060", s: "--c060s" },
  { id: "15.280", name: "Communication", full: "Communication for Leaders", v: "--c280", s: "--c280s" },
  { id: "15.311", name: "Org Processes", full: "Organizational Processes", v: "--c311", s: "--c311s" },
  { id: "15.515", name: "Financial Accounting", full: "Financial Accounting", v: "--c515", s: "--c515s" },
  { id: "15.900", name: "Competitive Strategy", full: "Competitive Strategy", v: "--c900", s: "--c900s" },
  { id: "15.403", name: "Practice of Finance", full: "Introduction to the Practice of Finance", v: "--c403", s: "--c403s" },
];

export const C = Object.fromEntries(CLASSES.map((c) => [c.id, c]));

/**
 * Who is NOT taking a given class. The single source of truth for enrollment gaps —
 * owner pickers grey these people out and load maths excludes them.
 *
 * Rahul is not in 15.900. 15.403 enrollment is not yet confirmed, so it is left open.
 */
export const NOT_ENROLLED = {
  "15.900": ["rahul"],
};

/** Effort weights. Team load is measured in these units, not in item counts. */
export const EFFORT = { S: 1, M: 2, L: 4 };

/** The lead carries most of a team deliverable; the second backs them up. */
export const LEAD_W = 0.7;
export const SECOND_W = 0.3;

export const STATUS_ORDER = ["todo", "doing", "review", "done"];
export const STATUS_LABEL = {
  todo: "To do",
  doing: "In progress",
  review: "Review",
  done: "Done",
};
